import React from 'react';
import styled from 'styled-components';
import { Field, FieldProps, FieldRenderProps } from 'react-final-form';
import { Checkbox } from 'primereact/checkbox';
import { Typography } from "../Typography";

interface FormCheckboxProps extends FieldProps<boolean, FieldRenderProps<boolean>> {
  id?: string;
}

export const FormCheckbox: React.FC<FormCheckboxProps> = props => {
  return (
    <Field
      type="checkbox"
      render={(checkboxProps) => (
        <StyledLabel id={props.id} htmlFor={props.name}>
          <StyledCheckbox
            checked={checkboxProps.input.value}
            inputId={props.name}
            {...checkboxProps.input}
            
          />
          <Typography variant="checkbox">{props.label}</Typography>
        </StyledLabel>
      )}
      {...props}
    />
  );
}

const StyledCheckbox = styled(Checkbox)`
  &.p-checkbox.p-highlight .p-checkbox-box {
    border-color: ${({ theme }) => theme.palette.checkbox.primary};
    background-color: ${({ theme }) => theme.palette.checkbox.primary};
  }
`;
const StyledLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
`;

